// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"89":"782329a1b2c64682","229":"83b5fb03b98de555","421":"d434ebd8ba206209","662":"ccf3e57edba61e36","915":"16addb77634c7131"}[chunkId] + ".js";
};